import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Input } from "antd";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { API_URLS } from "../../../../../api/apiUrls";
import { postApi } from "../../../../../api/api_instance";
import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../../../components/Elements/DialogBox/AcceptDialog";

const CreateLocation = ({ onOpen, onClose, onSuccess }) => {
  const [location_name, setlocation_name] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    location_name: "",
    description: "",
  });

  const handleSave = async () => {
    let isValid = true;
    const errors = { location_name: "", description: "" };

    if (!location_name) {
      errors.location_name = "location_name is required";
      isValid = false;
    }
    if (!description) {
      errors.description = "Description is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_LOCATIONUSER,
        data: { location_name, description },
      });

      if (response.success) {
        // toast.success("Location created successfully!");
        setShowAcceptDialog(true);
      } else {
        toast.error(response.message || "Failed to create Location.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setErrorMessage({});
    onClose();
  };
  const handleAcceptClose = () => {
    setShowAcceptDialog(false);
    if (onSuccess) onSuccess();
  };

  return (
    <>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Add New</h3>
        </div>

        <div className="rounded-xl border mt-8 px-12 py-6">
          <div className="flex flex-col gap-6">
            <Input
              value={location_name}
              onChange={(e) => setlocation_name(e.target.value)}
              placeholder="Location Name"
              className="h-14 rounded-lg"
            />
            {errorMessage.location_name && (
              <div className="text-red-500 text-sm">
                {errorMessage.location_name}
              </div>
            )}

            <Input.TextArea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description"
              className="rounded-lg"
              rows={10}
            />
            {errorMessage.description && (
              <div className="text-red-500 text-sm">
                {errorMessage.description}
              </div>
            )}
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
        </div>
      </DialogBox>

      {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={handleAcceptClose}
          heading="Location Created"
          subheading="Location has been successfully created."
          success={true}
        />
      )}
    </>
  );
};

export default CreateLocation;
